// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2V6zp","header":"MergedInvoice_header__H7cjl"};